export default "__VITE_ASSET__kNszzWDv__"